<template>
  <div class="newsdetails">
    <div class="back" @click="back">新闻公告列表</div>
    <div class="content">
      <h1>{{content.Title}}</h1>
      <div class="date">{{content.CreationTime}}</div>
      <div class="main-content" v-html="content.Content"></div>
    </div>
  </div>
</template>
<script>
import { getNewsContent } from "../../assets/js/modules/newsApi";
import { setTimeout } from "timers";

export default {
  data() {
    return {
      id: "",
      content: "",
      currentPage: ""
    };
  },
  methods: {
    getId() {
      this.id = this.$route.query.Id;
      this.currentPage = this.$route.query.Page;
    },
    back() {
      this.$router.push({
        path: "/news/newslist",
        query: { Page: this.currentPage }
      });
    },
    getcontent() {
      let data = {
        Id: this.id
      };

      getNewsContent(data).then(
        res => {
          this.content = res.data.Data;
        },
        err => {
          console.log(err);
        }
      );
    }
  },
  mounted() {
    this.getId();
    var that = this;
    setTimeout(function() {
      that.getcontent();
    }, 500);
  }
};
</script>
<style scoped>
.newsdetails {
  max-width: 1280px;
  width: 100%;
  background: #fff;
  margin: 30px auto;
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  color: #333333;
  padding-bottom: 30px;
}
.back {
  background: url("../../assets/img/back_icon.png") no-repeat 30px center;
  line-height: 66px;
  font-size: 20px;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  padding-left: 50px;
  color: #bcbcbc;
}
.content {
  width: 80%;
  margin: 0 auto;
}
.newsdetails h1 {
  font-size: 24px;
  line-height: 1.5;
  margin: 55px auto 20px;
  text-align: center;
}
.date {
  font-size: 12px;
  color: #d9d9d9;
  text-align: center;
}
.main-content {
  border-top: 1px solid #e7e7e7;
  margin: 40px 0 80px;
  padding: 0 40px;
}
.main-content >>> p {
  text-indent: 2em;
  font-size: 16px;
  line-height: 1.5;
  margin: 30px auto;
  color: #666666;
}
.main-content >>> img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/news/newsdetails.vue